import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ev5a2h5z8: FaireProductEntity = {
  token: "p_5ev5a2h5z8",
  type: "product",
  name: "OkLoveYouBye Little Pouch",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/73ab242d352588901c3538e45c3ad752a18e456620ce6ce2f8221875aaaea2cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/193c4da06b5e95bedb423f5d086cb4c67bfd839da028be3322a5ca195dae3992.jpeg",
    "https://cdn.faire.com/fastly/98dbbfed8cbd3aba751c407250d1ab64962c2c1d4954f1af974e62715459c137.jpeg",
    "https://cdn.faire.com/fastly/c49fb7fb4fd7158a6c129aa741ea3d462a0e6e4917c9a6042ae262afc99b7fab.jpeg",
  ],
  priceDollars: 8,
  description:
    'What other little product balances both “love” and “need” so perfectly? A pouch! Just the right size for all the small things that roam free in your bag, these charming zips make organizing a treat. And, with designs that coordinate beautifully with Little Notes® and other E. Frances favorites, they’re also perfect for gifting.\n\nEach pouch comfortably fits 2 packs of Little Notes® plus a set of Little Colored Pencils, making it a must-have for your Little Notes® collection.\n\nMeasuring 7" x 5" with a bottom gusset, matte gold zipper and pull, brilliant color and high-quality stitching—these are NICE!',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:47.243Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
